<template>
  <div class="obstacles-list">
    <list-container title="Obstacles" :items='items' :searchable="true">
      <template v-slot:default="slotProps">
        <div class='details clearfix'>
          <div class="stats">
            <div>
              <h3 v-html="colorize(slotProps.item.name())"></h3>
            </div>

            <ul class='seperated'>
              <li v-if='slotProps.item.conditionals()'>
                <b>CONDITIONS</b> <span v-html="colorize(slotProps.item.conditionals())"></span>
              </li>
            </ul>
          </div>

          <div class="effects">
            <div class="action-info">
              <p v-html="colorize(slotProps.item.description())"></p>
            </div>
          </div>
        </div>
      </template>
    </list-container>
  </div>
</template>

<script>
  import obstaclesCollection from './collection.js';
  import ListContainer from '../shared/list-container.vue';
  import colorizeKeywords from '../shared/colorize.js';

  export default {
    name: 'obstacles-app',

    components: { ListContainer },

    data: function(){
      return {
        collection: new obstaclesCollection(),
        items: []
      }
    },

    beforeMount() {
      const comp = this;

      this.collection.fetch().then(() => {
        this.items = comp.collection.alphabetical();
      });
    },

    methods: {
      colorize(text) { return colorizeKeywords(text); }
    }
  }
</script>
